"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionMappings = exports.PropertyMapping = exports.MAX_MAPPINGS_PER_CONNECTION = void 0;
const zod_1 = require("zod");
const types_1 = require("./types");
Object.defineProperty(exports, "MAX_MAPPINGS_PER_CONNECTION", { enumerable: true, get: function () { return types_1.MAX_MAPPINGS_PER_CONNECTION; } });
exports.PropertyMapping = zod_1.z.object({
    id: zod_1.z.string(),
    enabled: zod_1.z.boolean().default(true),
    // Scoping — which events this mapping applies to
    eventType: zod_1.z.enum(["track", "page", "identify", "*"]).default("*"),
    eventName: zod_1.z.string().optional(),
    // Source property path (dot notation, [] for array iteration)
    // Required for property mappings, omitted for static value mappings
    sourcePath: zod_1.z.string().optional(),
    // Destination property path (dot notation, [] for array iteration)
    destinationPath: zod_1.z.string(),
    // Static value to set on the destination path (used instead of sourcePath)
    staticValue: zod_1.z.string().optional(),
});
exports.ConnectionMappings = zod_1.z.object({
    mappings: zod_1.z.array(exports.PropertyMapping).max(types_1.MAX_MAPPINGS_PER_CONNECTION),
});
const propertyMappingInSync = true;
const connectionMappingsInSync = true;
void propertyMappingInSync;
void connectionMappingsInSync;
